/*constant variables for search configuration files */
export const JOBADVERTISEMENT_SEARCH_CONFIG_BASE_PATH = '/jobadvertisement/searchresult?configFile=';
export const SEARCH_CONFIG_JOBADVERTISEMENT = 'rm/erp/jobadvertisement/searchJobAdvertisement.xml';
